export default __webpack_public_path__ + "static/media/icon-telegram-mobile.60b3239a.svg";